import React, { useState, useEffect } from "react";
import CircularProgress from "@mui/material/CircularProgress"
import Box from "@mui/material/Box";
import Grid  from "@mui/material/Grid";
import axios from "axios";
import { SentimentDissatisfied } from "@mui/icons-material";
import { config } from '../App';
import VideoCard from "./VideoCard";

const Dashboard = ({genre, rating, sortBy, search}) => {
    const [loading, setLoading] = useState(false)
    const [videos, setVideos] = useState([])
    
    if(sortBy === "Release Date") {
      sortBy = "releaseDate"
    }
    else {
      sortBy = "viewCount"
    }

    const makeAPICall = async(e) => {
    // console.log(rating[0])
    let getURL = config.endpoint + '/v1/videos'
    try {
      setLoading(true)
      let res = await axios.get(getURL,{
        params: {
          genres: genre.join(","),
          contentRating: encodeURI(rating[0]),
          sortBy: sortBy,
          title: search
        }
      })
      // console.log(res.data.videos);
      setVideos(res.data.videos)
      setLoading(false)
    } catch (error) {
        // console.log("catch");
        console.log(error.message);
        console.log(error.name);
        setLoading(false)
    }
  }

  useEffect(() => {
    makeAPICall()
  },[genre, rating, sortBy, search])

  return (
    <>
      {loading ? (
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
          }}
        >
          <CircularProgress color="error" />
          <p style={{ paddingLeft: "5px", color: "#fff" }}>Loading Videos...</p>
        </Box>
      ) : (
        <Grid container spacing={1} mt={3}>
          {videos.length ? (
            videos.map((vid) => (
              <Grid item xs={6} md={3} p={1} key={vid._id}>
                <VideoCard vCard={vid} />
              </Grid>
            ))
          ) : (
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
              }}
            >
              <SentimentDissatisfied color="error" />
              <p style={{ paddingLeft: "5px", color: "#fff" }}>
                No Videos Found
              </p>
            </Box>
          )}
        </Grid>
      )}
    </>
  );
}

export default Dashboard